export type Args = {
  postal: string;
};

export type APIJSONData = {
  response: {
    error?: string;
    location?: {
      city: string;
      city_kana: string;
      town: string;
      town_kana: string;
      x: string;
      y: string;
      prefecture: string;
      postal: string;
    }[];
  };
};

/**
 * 郵便番号による住所検索 API
 *
 * @see https://geoapi.heartrails.com/api.html#postal
 */
export const searchByPostal = async ({ postal }: Args) => {
  try {
    const params = new URLSearchParams();
    params.append('method', 'searchByPostal');
    params.append('postal', postal);

    const res = await fetch(
      `https://geoapi.heartrails.com/api/json?${params.toString()}`,
      {
        method: 'GET',
      },
    );

    const data: APIJSONData = await res.json();

    return data.response.location;
  } catch (error) {
    console.error(error);

    throw new Error('郵便番号による住所検索に失敗しました');
  }
};
